export default __webpack_public_path__ + "static/media/xlsfile.3f92d7a4.svg";